import React from "react";
import type { DirectoryCardInfo, DirectoryCategoryInfo } from '@components/DirectoryCard/types'
import type { SupplierReview } from "./types";
import type { LoggedInUser } from "./types";
import { INITIAL_CATEGORY_COUNT } from "./constants";

export type BulkReviewsContextType = {
    categoryInfo: DirectoryCardInfo;
    reviews: SupplierReview[];
    isLoading: boolean;
    isLoggedIn: boolean;
    showValidationMessages: boolean;
    loggedInUser?: LoggedInUser;
    showCount: number;
    setShowCount?: (value: number) => void;
    addUpdateReview?: (review: SupplierReview) => void;
    addEmptyReview?: (supplierId: number, supplierName: string, category: DirectoryCategoryInfo, custom: boolean) => void;
    deleteReview?: (reviewId: number) => void;
    getLoggedInUser?: () => void;
    updateUser?: (profileUrl: string, imageId: number, firstName?: string, lastName?: string, email?: string, location?: string) => void;
    setShowValidationMessages?: (value: boolean) => void;
}

export const BulkReviewsContext = React.createContext<BulkReviewsContextType>({
    categoryInfo: {
        competitionEnabled: false,
        categories: [],
    },
    reviews: [],
    isLoading: false,
    isLoggedIn: false,
    showValidationMessages: false,
    loggedInUser: {
        FirstName: '',
        LastName: '',
        Email: ''
    },
    showCount: INITIAL_CATEGORY_COUNT
});

export default BulkReviewsContext;
